export const METRICS_REFRESH_INTERVAL: number = Number(process.env.REACT_APP_METRIC_REFRESH_INTERVAL) || 1*60000